import { useField, useFormikContext } from "formik";
import DatePicker, { ReactDatePickerProps } from "react-datepicker";

export const DatePickerField = ({ ...props }: ReactDatePickerProps) => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField({ name: props.name });
  // Convert timestamp to Date object if needed (for time pickers that store timestamps)
  const selectedValue =
    field.value === null || field.value === undefined
      ? null
      : typeof field.value === "number"
        ? new Date(field.value)
        : field.value;
  return (
    <DatePicker
      {...field}
      {...props}
      selected={selectedValue}
      onChange={(val: Date) => {
        setFieldValue(
          field.name,
          props.showTimeSelectOnly ? val.getTime() : val,
        );
      }}
    />
  );
};

export default DatePickerField;
